import React from 'react';
import {RouteHandler, State} from 'react-router';
import TopBar from 'rawr/controls/TopBar';
import Notifications from 'rawr/controls/Notifications';
import PoweredBy from 'rawr/style/PoweredBy';

export default React.createClass({
	mixins: [State],
	render() {
		return (
			<div>
				{/* TODO: Replace these links with the correct links and labels */}
				<TopBar home={{label: 'Home', href: '/', icon: 'home'}} />
				<Notifications />
				<RouteHandler {...this.props} />
				<PoweredBy styled={true} />
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/cbportal/handlers/Root.jsx
 **/